import axios from "axios";

import { config } from "@/Common/envConfig";

import { hasValue } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";
import { MILLISECONDS_TO_SECONDS } from "@/Utils/Date";

const checkConnection = async (): Promise<boolean> => {
  try {
    if (isValidString(config.checkConnetionResourceUrl)) {
      const response = await axios.get(config.checkConnetionResourceUrl, {
        timeout: config.checkConnectionSecsTimeout * MILLISECONDS_TO_SECONDS,
      });

      return hasValue(response) && hasValue(response.status) && response.status === 200;
    }
  } catch (e) {
    return false;
  }

  return true;
};

export default checkConnection;
